export default __webpack_public_path__ + "static/start-working-together-ff394b615963e6f7b593bda6181e04da.svg";